import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import falcop from "../Assets/falcop.jpg"
import "./Header.css"
import {AiOutlineMenu} from 'react-icons/ai'
import {RxCross2 } from 'react-icons/rx'

export default function Header() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" className="main_nav_bar">
      <Container>
        <Navbar.Brand href="#home" className='main_logo d-flex  gap-2  align-items-center justify-content'>
            <img src={falcop} alt="Falco P Logo" />
            <p className='marvel_coin_header robo_font mb-0'>Falco P</p>
            <div className='d-lg-none d-block'>
              <appkit-button />
            </div>

        </Navbar.Brand>
        {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
        <span className='d-block mb_bg_options d-lg-none' onClick={()=>setShow(!show)} >
        {
        
          show ? <><RxCross2 className='text-dark fs-1' /> </>:<><AiOutlineMenu className='text-dark fs-1'/></>
        }
        

        </span>
        <Navbar.Collapse id="responsive-navbar-nav"  className={show ? "show":""}>
          <Nav className="m-auto nav-buttons-container">
            <a href="#About" className="nav-button" onClick={handleClose}>About</a>
            <a href="#NFT" className="nav-button" onClick={handleClose}>NFT</a>
            <a href="#HowToMint" className="nav-button" onClick={handleClose}>How To Mint</a>
            <a href="#FAQ" className="nav-button" onClick={handleClose}>FAQ</a>
          </Nav>
          <Nav>
            <div className='d-none d-lg-block'>
              <appkit-button />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    
    </div>
  )
}
